import { render, staticRenderFns } from "./DeliveryProfile.vue?vue&type=template&id=39172a79&"
import script from "./DeliveryProfile.vue?vue&type=script&lang=ts&"
export * from "./DeliveryProfile.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryProfile.vue?vue&type=style&index=0&id=39172a79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports